export const directorAppointmentPermissions ={
    List: 8000,
    Create: 8001,
    Update: 8002,
    ShowDetails: 8003,
    Delete: 8004,
    AppointmentForAdministrations : 8005,
    AppointmentForDepartments : 8006,
     AppointmentForUnits : 8007,
     Approve : 8008,

}
export const AssignmentsPermissions ={
    List: 17000,
    Create: 17001,
    Update: 17002,
    ShowDetails: 17003,
    Delete: 17004,
}
export const EmployeeLeavesPermissions ={
    List: 16000,
    Create: 16001,
    Update: 16002,
    ShowDetails: 16003,
    Delete: 16004,
    Approve: 16005,
    Print: 16007,
    Return: 16006,
}
export const EmployeeTransferPermissions ={
    List: 18000,
    Create: 18001,
    Update: 18002,
    ShowDetails: 18003,
    Delete: 18004,
    Approve: 18005,
}
export const EmployeeDelegationsPermissions ={
    List: 19000,
    Create: 19001,
    Update: 19002,
    ShowDetails: 19003,
    Delete: 19004,
    Approve: 19005,
    Cancel: 19006,
}

export const EmployeeTerminationPermissions ={
    List: 29000,
    Create: 29001,
    Update: 29002,
    ShowDetails: 29003,
    Delete: 29004,
    Approve: 29005,
}


export const ComplaintsPermissions = {
    List: 24000,
    ShowDetails: 24003,
    Reply: 24005
}

export const DegreeDelegnationsPermissions = {
    List: 20000,
    Create: 20001,
    Update: 20002,
    ShowDetails: 20003,
    Delete: 20004,
    Approve: 20005,
    Cancel: 20006,


}


export const  PromotionPermissions=
{
    List :21000,
    Create :21001,
    Update :21002,
    ShowDetails :21003,
    Delete :21004,
    Approve :21005,
}
export const  GrievancesPermissions=
{
    List :31000,
    Create :31001,
    Update :31002,
    ShowDetails :31003,
    Delete :31004,
    Approve :31005,
}
export const  RetirementsPermissions=
{
    List :30000,
    Create :30001,
    Update :30002,
    ShowDetails :30003,
    Delete :30004,
    Approve :30005,
}
export const  BonusPermissions=
{
    List :22000,  
}

export const  NotificationsPermissions=
{
    List :23000,     
    ShowDetails :23003,
    Approve :23005,
    Extension :23006,

}


export const EmployeesCorrectionPermissions ={
    List: 32000,
    Create: 32001,
    Update: 32002,
    ShowDetails: 32003,
    Delete: 32004,
    Approve: 32005,
}
